<template>
  <wrapper>
    <div style="padding-top:10px;">
      <h5>{{ data.subject.name }} </h5>
      <h5> {{ data.name }}</h5>

      <div class="row">
        <div class="row center" v-if="data.link==null">
        
        </div>
        <div class="col m8 offset-m2" v-else>
          <div class="video_container" v-if="data.type==1">
            <video :src="data.link" controls controlslist="nodownload" oncontextmenu="return false;">
              <source />Your browser does not support the link tag.
            </video>
          </div>
          <div class="video_container" v-if="data.type==2">
            <audio :src="data.link" controls controlslist="nodownload" oncontextmenu="return false;">
              <source />Your browser does not support the link tag.
            </audio>
          </div>
          <div class="video_container" v-if="data.type==3">
           <video :src="data.link" controls controlslist="nodownload" oncontextmenu="return false;">
              <source />Your browser does not support the link tag.
            </video>
          </div>
          <div class="video_container" v-if="data.type==4">
            <audio :src="data.full_path" controls controlslist="nodownload" oncontextmenu="return false;">
              <source />Your browser does not support the link tag.
            </audio>
          </div>
          <div class="row" style="margin-top:30px;">
              <h6>Lecture Description</h6>
              <p>{{ data.description }}</p>
          </div>
         
        </div>
        
      </div>
      <div class="row" style="margin-top:30px;">
              <h6>Related Documents</h6>
              <ul class="collection with-header">
                
                <a v-for="item in data.related_documents" :href="item.full_path" target="_blank"><li class="collection-item">{{ item.name }}</li></a>
                
            </ul>
 
        </div>
    </div>
  </wrapper>
</template>
<script>
export default {
    mounted()
    {
        this.$store.dispatch("get_lecture",{id:this.$route.params.id});
    },
    computed:{
        loading()
        {
            return this.$store.getters.lecture_loading;
        },
        data()
        {
            return this.$store.getters.each_lecture;
        }
    }
};
</script>
<style lang="scss" scoped>
.video_container video {
  margin-top: 20px;
  width: 100%;
  height: 400px;
}
</style>